import { useEffect } from "react";

// Rascunhos locais por separador (sessionStorage): sobrevivem a novo login, apagam-se ao fechar o separador.
const PREFIX = "mio:draft:";

export function readDraft(key) {
  try { const raw = sessionStorage.getItem(PREFIX + key); return raw ? JSON.parse(raw) : null; }
  catch { return null; }
}

export function clearDraft(key) {
  try { sessionStorage.removeItem(PREFIX + key); } catch { /* */ }
}

export function useDraft(key, value, dirty = true) {
  useEffect(() => {
    if (!key || value == null) return;
    if (!dirty) { clearDraft(key); return; }
    const t = setTimeout(() => {
      try { sessionStorage.setItem(PREFIX + key, JSON.stringify(value)); } catch { /* */ }
    }, 400);
    return () => clearTimeout(t);
  }, [key, value, dirty]);
}
